import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

const DESKTOP_RTF_COPY_FLAG = 'release-scribe-desktop-rtf-copy';

export const isDesktopRtfCopyEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    DESKTOP_RTF_COPY_FLAG,
    false
  );

export const useIsDesktopRtfCopyEnabled = (): boolean =>
  useBooleanFlagValue(DESKTOP_RTF_COPY_FLAG, false);
